import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {SidebarSection} from 'shells/setup/sidebar-section/sidebar-section';
import type {SidebarSectionLink} from 'shells/setup/sidebar-section/sidebar-section';

import {TitleBarLimits} from '../../../limits';

import {TeamsUpsellButton} from './teams-upsell-button';

type Team = {
    name: string;
    urlPath: string;
    usersCount: number;
};

export type Props = {
    teams: Team[];
};

export function TeamsSidebarSection(props: Props) {
    const {teams} = props;

    const teamsLinks: SidebarSectionLink[] = [];

    if (NutClientConfig.hasTeams) {
        teamsLinks.push({
            to: '/setup/user?teamId=new',
            label: 'Create a new team',
            type: 'create',
        });
    }

    teams.forEach((team) => {
        teamsLinks.push({
            to: team.urlPath,
            label: team.name,
            isActive: window.location.href.includes(team.urlPath),
            count: team.usersCount,
        });
    });

    return (
        <SidebarSection
            title={
                <StackLegacy spacing={4} isHorizontal={true} alignCenter={true}>
                    <div>Teams</div>
                    {NutClientConfig.hasTeams ? (
                        <TitleBarLimits type='TEAMS' />
                    ) : (
                        <TeamsUpsellButton />
                    )}
                </StackLegacy>
            }
            links={teamsLinks}
        />
    );
}
